import React from 'react';
import { ArrowRight, Users } from 'lucide-react';
import DecorativeImage from './DecorativeImage';

const AboutSection = ({ onOpenModal }) => (
  <section className="py-24 bg-[#F9F8F6]" data-testid="home-about-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">

      {/* Centered Badge + Main Heading */}
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 bg-[#1A3628] text-white text-xs font-body font-medium uppercase tracking-[0.2em] px-5 py-2.5 rounded-full mb-6">
          <Users className="h-4 w-4" strokeWidth={1.5} />
          About Our Service
        </div>
        <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter leading-tight">
          Leading Trademark Registration Firm
        </h2>
        <p className="font-body text-base text-[#4A5D53] mt-4">
          We have filed trademarks for a number of brands with 98% USPTO approval success which highlights our expertise.
        </p>
      </div>

      {/* Split Layout: Image Left + Content Right */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

        {/* Left — Image */}
        <div data-testid="about-section-image">
          <DecorativeImage
            src="/assets/img/about01.webp"
            alt="Modern office interior"
          />
        </div>

        {/* Right — Heading + Paragraph + Button */}
        <div data-testid="about-section-content">
          <h3 className="font-display text-3xl md:text-4xl font-bold text-[#111C16] tracking-tight leading-tight mb-6">
            Federal Trademark Protection
          </h3>
          <p className="font-body text-base text-[#4A5D53] leading-relaxed mb-4">
            Your brand identity deserves professional legal protection. We provide comprehensive USPTO trademark registration services that give you exclusive nationwide rights to your business name, logo, and slogan.
          </p>
          <p className="font-body text-base text-[#4A5D53] leading-relaxed mb-8">
            Our experienced IP attorneys have successfully filed a number of trademarks with an industry-leading <strong className="text-[#C85A40]">98% approval rate</strong>. From initial search to final registration, we handle everything for you.
          </p>
          <button
            onClick={() => onOpenModal?.('About Section')}
            className="bg-[#C85A40] hover:bg-[#A64730] text-white font-body font-medium px-8 py-4 rounded-full transition-colors flex items-center gap-2"
            data-testid="about-section-cta-button"
          >
            Register My Trademark
            <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </button>
        </div>

      </div>
    </div>
  </section>
);

export default AboutSection;
